<template>
  <role-index title="Roles de Onboarding" onboarding :admin="false" />
</template>

<script>
import RoleIndex from '../RoleIndex'
export default {
  components: { RoleIndex }
}
</script>

<style></style>
